import React from 'react';
import classNames from 'classnames';

import { StyledOcticon } from '@primer/react';

export const Badge = ({
  children,
  className = 'p-2 w-24',
  bgColor = 'bg-gray-500',
  textColor = 'text-white',
}) => (
  <div className={classNames(`inline-block rounded border-0 ${bgColor} ${textColor}`, className)}>
    {children}
  </div>
)

export const IconBadge = ({
  children,
  icon,
  iconSize = 14,
  className = 'p-2 w-24',
  bgColor = 'bg-gray-500',
  textColor = 'text-white',
}) => (
  <div className={classNames(`inline-block rounded border-0 ${bgColor} ${textColor}`, className)}>
    <div className="flex flex-row justify-center items-center">
      <StyledOcticon
        className="mr-2"
        icon={icon}
        size={iconSize}
      />
      {children}
    </div>
  </div>
)

export default Badge;
